import en from "./english";
import du from "./dutch";
export const PLACEHOLDERS = {
  en,
  du,
};
